import { c as _c } from "react/compiler-runtime";
import { TabPanel, type TabPanelProps } from "@mui/lab";
import { Box } from "@mui/material";
import { TabContentScrollContainer } from "./TabContentScrollContainer";
type StyledTabPanelProps = TabPanelProps & {
  scrollContainerStyle?: React.CSSProperties;
  scrollViewportStyle?: React.CSSProperties;
  useScroll?: boolean;
  overlay?: React.ReactNode;
  containerId?: string;
};
export const StyledTabPanel: React.FC<StyledTabPanelProps> = t0 => {
  const $ = _c(36);
  let children;
  let containerId;
  let overlay;
  let restProps;
  let scrollContainerStyle;
  let scrollViewportStyle;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      scrollContainerStyle,
      scrollViewportStyle,
      useScroll: t1,
      overlay,
      containerId,
      sx,
      children,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = containerId;
    $[3] = overlay;
    $[4] = restProps;
    $[5] = scrollContainerStyle;
    $[6] = scrollViewportStyle;
    $[7] = sx;
    $[8] = t1;
  } else {
    children = $[1];
    containerId = $[2];
    overlay = $[3];
    restProps = $[4];
    scrollContainerStyle = $[5];
    scrollViewportStyle = $[6];
    sx = $[7];
    t1 = $[8];
  }
  const useScroll = t1 === undefined ? true : t1;
  let t2;
  if ($[9] !== sx) {
    t2 = {
      p: 2,
      display: "flex",
      flexDirection: "column",
      ...sx
    };
    $[9] = sx;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const sxProps = t2;
  if (useScroll) {
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        p: 0,
        minHeight: 10,
        flexGrow: 1
      };
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== scrollContainerStyle) {
      t4 = {
        height: "100%",
        ...scrollContainerStyle
      };
      $[12] = scrollContainerStyle;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== children || $[15] !== containerId || $[16] !== sxProps) {
      t5 = <Box id={containerId} sx={sxProps}>{children}</Box>;
      $[14] = children;
      $[15] = containerId;
      $[16] = sxProps;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    let t6;
    if ($[18] !== scrollViewportStyle || $[19] !== t4 || $[20] !== t5) {
      t6 = <TabContentScrollContainer defer={true} style={t4} viewportStyle={scrollViewportStyle}>{t5}</TabContentScrollContainer>;
      $[18] = scrollViewportStyle;
      $[19] = t4;
      $[20] = t5;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    let t7;
    if ($[22] !== overlay || $[23] !== restProps || $[24] !== t6) {
      t7 = <TabPanel sx={t3} {...restProps}>{overlay}{t6}</TabPanel>;
      $[22] = overlay;
      $[23] = restProps;
      $[24] = t6;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    return t7;
  }
  let t3;
  if ($[26] !== sxProps) {
    t3 = {
      flex: 1,
      minHeight: 0,
      ...sxProps
    };
    $[26] = sxProps;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  let t4;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column"
    };
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  let t5;
  if ($[29] !== children || $[30] !== containerId) {
    t5 = <Box id={containerId} sx={t4}>{children}</Box>;
    $[29] = children;
    $[30] = containerId;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== restProps || $[33] !== t3 || $[34] !== t5) {
    t6 = <TabPanel sx={t3} {...restProps}>{t5}</TabPanel>;
    $[32] = restProps;
    $[33] = t3;
    $[34] = t5;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  return t6;
};